import template from './employees_active_per_department_count_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeesActivePerDepartmentCountHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeesActivePerDepartmentCountHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeesActivePerDepartmentCountHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeesActivePerDepartmentCountHelp',
	dialog_class: EmployeesActivePerDepartmentCountHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employees_active_per_department_count_help',
	provider: 'ps'
};
